export default "__VITE_ASSET__DWlN5YGw__"